import { jsx as e } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.25C3.25736 2.25 2.25 3.25736 2.25 4.5V19.4999C2.25 20.7425 3.25736 21.7499 4.5 21.7499H19.5C20.7426 21.7499 21.75 20.7425 21.75 19.4999V4.5C21.75 3.25736 20.7426 2.25 19.5 2.25H4.5ZM14.7145 7.82601H13.6805C12.8665 7.82601 12.7125 8.20001 12.7125 8.77751V10.026H14.6485L14.3955 11.984H12.7125V17H10.6885V11.984H9V10.026H10.6885V8.58501C10.6885 6.91302 11.7115 6.00002 13.2075 6.00002C13.7108 5.99926 14.2139 6.02496 14.7145 6.07702V7.82601Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
